var timer = null;
var smsToken = null;
var frontBaseUrl = "http://testlxgroup.xhd.cn/";
let ajax = function (url, param, type = 'POST') {
  const promise = new Promise(function (resolve, reject) {
    $.ajax({
      type: type,
      url: url,
      data: param,
      dataType: 'json',
      success(res) {
        resolve(res)
      },
      error(res) {
        reject('响应错误')
        // reject(res.statusText)
      }
    })
  })
  return promise
}
let common={
  timerDown:null,
  init(){
    this.verify()
    this.sendCode()
    this.selectCountry()
    this.getImgCode()
  },
  sendCode(){
    $(".signup_item_sendcode").click(function(){
      if(!$(this).hasClass("disabled")){
        if(common.validate('phone')&&common.validate('imgcode')){
          var data = {
            sid: 3,
            mobile: $("input[name=mobile]").val(),
            businessName: "客户预约",
            moduleName: "留学方案定制",
            captchaId: $("input[name=captchaId]").val(),
            captcha: $("input[name=captcha]").val(),
          };
          $.get(frontBaseUrl + "common/sms", data, function (res) {
            if (res.code == 200) {
              common.timeDown($(this));
              smsToken = res.token;
            }
            showMsg(res.msg);
          });
        }
      }
    })
  },
  getImgCode(){
    $.post(frontBaseUrl + "common/captcha", function (res) {
      var img = "data:image/jpg;base64," + res.captcha;
      var captchaId = res.captchaId;
      $("#captcha").attr("src", img);
      $("input[name=captchaId]").val(captchaId);
    });
  },
  verify(){
    $("#dingzhi").click(function(){
      if(common.validate('name')&&common.validate('phone')&&common.validate('country')&&common.validate('imgcode')&&common.validate('code')){
        var data = {
          sid: 3,
          name: $("input[name=name]").val(),
          mobile: $("input[name=mobile]").val(),
          educationType: $("#educationType").val(),
          businessName: "客户预约",
          moduleName: "留学方案定制",
          token: smsToken,
          intentionalAreaArray: $("#intentionalArea").val(),
          provinceType: $("#provinceType").val(),
          smsCode: $("input[name=smsCode]").val(),
        };
        $.get(frontBaseUrl + "customer/insert", data, function (res) {
          if (res.code == 200) {
            showMsg("您的信息已提交，我们会尽快与您联系！");
            $("input[name=mobile]").val("");
            $("input[name=smsCode]").val("");
            $("input[name=captcha]").val("");
            common.getImgCode();
          } else {
            showMsg(res.msg);
          }
        });
      }
    })
    $("#captcha").click(function() {
      common.getImgCode()
    });
  },
  validate(type){
    let msg=''
    let msg2=''
    let reg=null
    let val=$(".signup_input."+type).val().trim()
    switch(type){
      case 'name':
        msg='姓名不能为空'
        msg2='请输入正确的中文姓名'
        reg=/^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/
        break;
      case 'phone':
        msg='手机号不能为空'
        msg2='请输入正确的手机号'
        reg=/^1\d{10}$/
        break;
      case 'country':
        msg='国家不能为空'
        msg2='国家不能为空'
        reg=/^.{1,}$/
        break;
      case 'imgcode':
        msg='图形验证码不能为空'
        msg2='请输入正确的图形验证码'
        reg=/^\d{4}$/
        break;
      case 'code':
        msg='短信验证码不能为空'
        msg2='请输入正确的短信验证码'
        reg=/^\d{6}$/
        break;
      default:break;  
    }
    if(!val){
      showMsg(msg)
      return false
    }else if(!reg.test(val)){
      showMsg(msg2)
      return false
    }else{
      return true
    }
  },
  timeDown(target) {
    let sendTime = 120
    target.text( sendTime + '秒')
    target.addClass('disabled')
    target.closest('.signup_form').find('.phone').attr('disabled', 'true')
    common.timerDown = setInterval(function () {
        if (sendTime <= 1) {
            clearInterval(common.timerDown)
            target.text('获取验证码')
            target.removeClass('disabled')
            target.closest('.signup_form').find('.phone').removeAttr('disabled')
        } else {
            sendTime--
            target.text( sendTime + '秒')
        }
    }, 1000)
  },
  selectCountry(){
    $(".signup_input.country").click(function(e){
      e.stopPropagation()
      $(".signup_select").show()
    })
    $("body").click(function(e){
      if ($(e.target).hasClass("signup_select_item")) {
        return;
      }
      $(".signup_select").hide()
    })
    $(".signup_select_item").click(function(){
      if ($(this).hasClass('selected')) {
        $(this).removeClass("selected");
      }else {
        $(this).addClass("selected");
      }
      let str = "";
      let intentionalAreaType = "";
      $(".signup_select_item.selected").each((index,list) => {
        if (index > 0) {
          str += "," + $(list).text();
          intentionalAreaType += "," + $(list).attr("aid");
        } else {
          str += $(list).text();
          intentionalAreaType += $(list).attr("aid");
        }
      })
      console.log(intentionalAreaType);
      $("#intentionalArea").val(intentionalAreaType);
      $(".signup_input.country").val(str)
    })
  }
}
common.init()
function showMsg(str) {
  clearTimeout(timer);
  $(".common_msg").text(str);
  $(".common_msg").removeClass("hide");
  timer = setTimeout(function () {
    $(".common_msg").addClass("hide");
  }, 3000);
}